/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Attribute } from './attribute';
import { AttributeDefinition } from './attributeDefinition';
import { BusinessObjectFormatExternalInterfaceKey } from './businessObjectFormatExternalInterfaceKey';
import { BusinessObjectFormatKey } from './businessObjectFormatKey';
import { Schema } from './schema';


export interface BusinessObjectFormat { 
    /**
     * The internal identifier that uniquely identifies a Business Object Format
     */
    id?: number;
    /**
     * The Namespace to which a Business Object Format is related
     */
    namespace: string;
    /**
     * The name of the Business Object Definition to which a Business Object Format is related
     */
    businessObjectDefinitionName: string;
    /**
     * The Usage of this Business Object Format - a string describing how this format is used. Often used as a label for the Business                   Object Format. Does not have to be unique in the system, the Usage string is frequently shared across formats for multiple Business Object                   Definitions                
     */
    businessObjectFormatUsage: string;
    /**
     * A File Type known to the system that describes the file type of data stored under a Business Object Format
     */
    businessObjectFormatFileType: string;
    /**
     * The numeric version of a Business Object Format. Each time a format is registered, the new version will be the previous version                   + 1                
     */
    businessObjectFormatVersion?: number;
    /**
     * A Y/N flag that shows whether this instance of format is the latest or not. Once a new version of format is registered, any                   previous versions will no longer be the latest                
     */
    latestVersion?: boolean;
    /**
     * The partition key for this Business Object Format
     */
    partitionKey: string;
    /**
     * Description of the Business Object Format
     */
    description?: string;
    /**
     * The schema for document-style business object data registered with Herd
     */
    documentSchema?: string;
    /**
     * An optional URL of the documentSchema to an externally hosted XSD or JSON. Herd will not access this URL,                   it will simply store and retrieve the URL and teams can then access the URL                
     */
    documentSchemaUrl?: string;
    /**
     * An optional Sample Query information for the Business Object Format
     */
    sampleQuery?: string;
    /**
     * An optional Usage Notes for the Business Object Format
     */
    usageNotes?: string;
    /**
     * An optional Singleton Type designation for the Business Object Format
     */
    singletonType?: string;
    /**
     * An optional Availability Day for the Business Object Format
     */
    availabilityDay?: string;
    /**
     * An optional Publishing Frequency for the Business Object Format
     */
    publishingFrequency?: string;
    /**
     * Custom user-defined metadata associated with this Business Object Format. \"name\" is the attribute name (i.e. the key) and                   \"value\" is the attribute value.                
     */
    attributes?: Array<Attribute>;
    /**
     * List of attribute definitions (for storage of custom user-defined metadata with objects) which are required to be specified                   when registering Business Object Data against this format. This list will define which metadata must be specified, but additional metadata can                   still be registered which is not specified in this list. The metadata (attributes) will allow applications to store custom data with                   registered data for use by consumers of the data                
     */
    attributeDefinitions?: Array<AttributeDefinition>;
    /**
     * If true, enables Business Object Data Published Attributes Change Event Notification for all business object data registered                   under this business object format version                
     */
    enableBusinessObjectDataPublishedAttributesChangeEventNotification?: boolean;
    schema?: Schema;
    /**
     * A list of Business Object Data parents (i.e. predecessors) that were used/needed in the creation of this data. This is used for                   data lineage. Each parent consists of the key data that uniquely defines a reference to a single Business Object Data.                
     */
    businessObjectFormatParents?: Array<BusinessObjectFormatKey>;
    /**
     * A list of Business Object Data children that were creation from this data. This is used for data lineage. Each child consists                   of the key data that uniquely defines a reference to a single Business Object Data.                
     */
    businessObjectFormatChildren?: Array<BusinessObjectFormatKey>;
    /**
     * A list of business object format to external interface mappings
     */
    businessObjectFormatExternalInterfaces?: Array<BusinessObjectFormatExternalInterfaceKey>;
    /**
     * Indicates if business object data registered with this format is a record                
     */
    recordFlag?: boolean;
    /**
     * Indicates business object format record code                
     */
    recordCode?: string;
    /**
     * Indicate if this Business Object Format is under legal hold
     */
    legalHold?: boolean;
    /**
     * Retention period (in days) for business object data registered with this format.                
     */
    retentionPeriodInDays?: number;
    /**
     * Retention type. Supported retention types: PARTITION_VALUE, BDATA_RETENTION_TYPE.                
     */
    retentionType?: string;
    /**
     * If true, allows non backwards compatible changes to the schema                
     */
    allowNonBackwardsCompatibleChanges?: boolean;
    /**
     * Contains Relational Schema Name if the Format is of type Relational Table
     */
    relationalSchemaName?: string;
    /**
     * Contains Relational Table Name if the Format is of type Relational Table
     */
    relationalTableName?: string;
}
